import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "hooks/authentication/useAuth";
import Layout from "components/common/layout/Layout";

export const RequireAuth = ({ children }) => {
  const location = useLocation();
  const auth = useAuth();
  const unauthorized = window.location.pathname === "/unauthorized-user";

  const style = {
    width: "100%",
    marginTop: !unauthorized && "50px",
    marginLeft: !unauthorized && auth.user ? "230px" : "0",
  };
  if (!auth.user) {
    return <Navigate to="/login" state={{ path: location.pathname }} />;
  }
  return (
    <Layout>
      <div className="layout-right-margin" style={style}>
        {children}
      </div>
    </Layout>
  );
};
